import React, { useState } from 'react'
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';
import { BASE_URL_BUMPPY } from '../../../utils/Constants';

export default function DailyRecon() {
    const [apiData, setApiData] = useState(null);
    const [txnCount, setTxnCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const getYesterdayDate = () => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date.toISOString().split('T')[0];
    };

    const [selectedDate, setSelectedDate] = useState(getYesterdayDate());

    const formattedDateDisplay = new Date(selectedDate).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });


    const handleSubmit = async (e) => {
        setLoading(true);



        try {
            setSuccessMessage("")
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");


            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            const response = await fetch(
                `${BASE_URL_BUMPPY}${API_ENDPOINTS.DAILY_RECON}`,
                 requestOptions);
            const result = await response.json();
            setApiData(result)

            if (result && result.data && Array.isArray(result.data)) {
                const [year, month, day] = selectedDate.split('-');
                const apiFormatDate = `${day}-${month}-${year}`;
                const filtered = result.data.filter(item => item.transactionDate === apiFormatDate);
                setApiData({ ...result, data: filtered });
                setTxnCount(filtered.length);
                setSuccessMessage("Successfully Posted all transactions");
            } else {
                setApiData(result);
                setTxnCount(0);
            }



        } catch (err) {
            console.error('Server error occurred');
        } finally {
            setLoading(false);
        }
    };


  return (
      <div className="page-container">
          <div className="card-wrapper">
              <h1 className="title-header">
                  Hit the Unreported TXN of Aeps CW
              </h1>

              <div className="date-section">
                  <label className="date-label">Select Transaction Date</label>
                  <input
                      type="date"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      className="date-input"
                  />
              </div>

              <div className="action-footer">
                  <div className="stats-info">
                      <span className="stats-label">Date</span>
                      <span className="stats-value">{formattedDateDisplay}</span>
                      <div className="count-row">
                          <p className="count-label">Total count of txn :</p>
                          <p className='count-txn' >{txnCount}</p>
                      </div>
                  </div>

                  <button
                      onClick={handleSubmit}
                      disabled={loading}
                      className={`submit-btn ${loading ? 'btn-disabled' : 'btn-active'}`}
                  >
                      {loading ? 'Processing...' : 'Submit'}
                  </button>
              </div>

              {successMessage && (
                  <div className="msg-success">
                      <svg style={{ height: '20px', width: '20px', color: '#22c55e' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <p className="success-text">{successMessage}</p>
                  </div>
              )}

              {apiData && (
                  <div className="api-response-wrapper">
                      <p className="response-label">Response Data:</p>
                      <div className="response-box">
                          <pre className="json-output">
                              {JSON.stringify(apiData, null, 2)}
                          </pre>
                      </div>
                  </div>
              )}
          </div>
      </div>
  )
}
